import { Component } from '@angular/core';

@Component({
    selector: 'app-rp-confirmation',
    templateUrl: './confirmation.component.html',
    standalone: false
})
export class ResetPasswordConfirmationComponent {}
